import React from "react";
import "./../../UaeAttestation/UaeReq/UaeReq.css";

const GermanyReqMain = () => {
  return (
    <div className="uaeReqMainContainer">
      <div className="uaeReqMainContent">
        <h3>Requirement of apostille for Germany:</h3>
        <p>
          Legalization for Germany has its own importance in the visa procedure
          & expansion of the business in Germany. Apostille is needed as it is
          one of the countries that are a part of the Hague Convention which is
          also known as the Apostille Convention. There are policies of Germany
          that require documents with MEA sticker to permit a visitor to enter
          their country. It is a part of security that exhibits the
          trustworthiness of the documents. Therefore, verification of documents
          becomes important for these reasons.
        </p>
      </div>
      <div className="uaeReqMainContent">
        <h3>Overall time to get Document Apostille:</h3>
        <p>
          The time period required forApostille for Germanydepends upon various
          factors such as which state the certificate was issued from, or the
          sorts of documents, or the organization you require it from.
          Generally, it will take around 2-3 working days accomplish the whole
          process of Germany Apostille service in Bangalore for certificates.
        </p>
      </div>
    </div>
  );
};

export default GermanyReqMain;
